import { render, staticRenderFns } from "./AddClientAccount.vue?vue&type=template&id=32acf334"
import script from "./AddClientAccount.vue?vue&type=script&lang=ts"
export * from "./AddClientAccount.vue?vue&type=script&lang=ts"
import style0 from "./AddClientAccount.vue?vue&type=style&index=0&id=32acf334&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports